import { render } from "./PersonalAccounts.vue?vue&type=template&id=fd5f128e"
import script from "./PersonalAccounts.vue?vue&type=script&lang=js"
export * from "./PersonalAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__